import { queryOptions } from '@tanstack/react-query';

import { type VehicleListFilters } from './types';
import * as supabaseSource from './vehicles.api';

// Vehicles always come from Supabase; there is no sample-data branch.
const source = () => Promise.resolve(supabaseSource);

/** Query factories: the only way UI code reaches vehicle data. */
export const vehicleKeys = {
  all: ['vehicles'] as const,
  list: (filters: VehicleListFilters) => [...vehicleKeys.all, 'list', filters] as const,
  detail: (slug: string) => [...vehicleKeys.all, 'detail', slug] as const,
  media: (listingId: string) => [...vehicleKeys.all, 'media', listingId] as const,
  facets: () => [...vehicleKeys.all, 'facets'] as const,
};

export const vehicleListQuery = (filters: VehicleListFilters = {}) =>
  queryOptions({
    queryKey: vehicleKeys.list(filters),
    queryFn: async () => (await source()).listVehicles(filters),
  });

export const vehicleDetailQuery = (slug: string) =>
  queryOptions({
    queryKey: vehicleKeys.detail(slug),
    queryFn: async () => (await source()).getVehicleBySlug(slug),
  });

export const vehicleMediaQuery = (listingId: string) =>
  queryOptions({
    queryKey: vehicleKeys.media(listingId),
    queryFn: async () => (await source()).listVehicleMedia(listingId),
  });

export const vehicleFacetsQuery = () =>
  queryOptions({
    queryKey: vehicleKeys.facets(),
    queryFn: async () => (await source()).getVehicleFacets(),
    staleTime: 5 * 60_000,
  });
